import("jquery");
import("../src/javascripts/auto-play-animations");
import("../src/javascripts/attachments-redesign");
import("../src/javascripts/easy-toggle");
import("../src/javascripts/intersection-observers");
import("../src/javascripts/stories");
import("../src/javascripts/swiper");
import("../src/javascripts/navigation");
import("../src/javascripts/slider_splide");
import("../src/javascripts/smooth-scroll-to-anchor");

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
